import { css } from 'emotion';

import { colors } from '../styles';

export const option = css`
  height: 19px; /* some elements may come with empty label, we don't want them to be a small line. This is the specified zeplin height */
  line-height: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: flex-start;

  /* selected icon styling */

  & + svg {
    color: ${colors.success.default};
    flex-shrink: 0;
    margin-left: 5px;
  }

  /* optional option icon */

  & > svg {
    margin-right: 6px;
    width: 19px;
    height: 19px;

    && {
      font-size: 19px;
    }
  }
`;

export const errorMessage = css`
  display: block;
  margin-top: 5px;
  flex-grow: 1;
`;
